import Vue from 'vue'
import {SERVER_HOST} from "@/_global/global_variables";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";


// ファイルサーバーのホストを付与
function fullPath(file: string) {
    let str_host = SERVER_HOST.MEDIA ? SERVER_HOST.MEDIA + "/" : "";
    return file ? str_host + file : "";
}

// フィルタ登録
export default function globalFilters() {
    // 3桁区切りでカンマをつける
    Vue.filter('withComma', (val: any) => Number(val).toLocaleString());

    // リソース取得先
    Vue.filter('fullPath', (file: string) => fullPath(file));

    // 商品イメージのURL取得
    Vue.filter('itemImage', (id: number) => {
        const item = ItemsStore.itemById[id];
        return item ? fullPath(item.image_url) : "";
    });

    // week値→曜日変換
    const dayOfWeekList: { [day: number]: string } = {0: "日", 1: "月", 2: "火", 3: "水", 4: "木", 5: "金", 6: "土"};
    Vue.filter('dayOfWeek', (day: number) => dayOfWeekList[day] || "");

};
